import { EventService } from 'src/app/services/event.service';
import { environment } from './../../../environments/environment';
import { FinalizeRegistrationRequest } from './../../models/FinalizeRegistrationRequest';
import { RegistrationResult } from '../../models/RegistrationResult';
import { Captcha } from '../../models/Captcha';
import { Sponsorship } from '../../models/Sponsorship';
import { Speaker } from '../../models/Speaker';
import { SessionTrack } from '../../models/SessionTrack';
import { Session } from '../../models/Session';
import { Pass } from '../../models/Pass';
import { HttpHelper } from '../../helpers/HttpHelper';
import { Injectable, Inject } from '@angular/core';
import { Event } from '../../models/Event';
import { Observable } from 'rxjs';
import { RegistrationData } from '../../models/RegistrationData';
import * as CustomRegistrationFieldModel from '../../models/CustomRegistrationField';
import { HTTP_HELPER } from 'src/app/providers/http.helper.provider';
import { Console } from 'console';

@Injectable()
export class EventD365Service implements EventService {

    private static readonly eventsEndpoint: string = 'events';// new Event (Preview) - PROD
    private static readonly usersEndpoint: string = 'users';

    constructor(@Inject(HTTP_HELPER) private http: HttpHelper) {
    }

    public getPublishedEvents(): Observable<Event[]> {
        const url = `${environment.apiEndpoint_PROXY}/?mode=events-published`;
        // console.log('getPublishedEvents: '+url);
        return this.http.get<Event[]>(url);
    }

    public getEvent(readableEventId: string): Observable<Event> {
        // console.log('getEvent: '+readableEventId);
        return this.http.get<Event>(
            `${environment.apiEndpoint_PROXY}/?mode=event&eventId=${readableEventId}`
        );
    }

    public getPasses(readableEventId: string): Observable<Pass[]> {
        // console.log('getPasses: '+readableEventId);
        return this.http.get<Pass[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-passes&eventId=${readableEventId}`
        );
    }

    public getSessions(readableEventId: string): Observable<Session[]> {
        // console.log('getSessions: '+readableEventId);
        return this.http.get<Session[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-sessions&eventId=${readableEventId}`
        );
    }

    public getSessionTracks(readableEventId: string): Observable<SessionTrack[]> {
        // console.log('getSessionTracks: '+readableEventId);
        return this.http.get<SessionTrack[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-tracks&eventId=${readableEventId}`
        );
    }

    public getSpeakers(readableEventId: string): Observable<Speaker[]> {
        // console.log('getSpeakers: '+readableEventId);
        return this.http.get<Speaker[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-speakers&eventId=${readableEventId}`
        );
    }

    public getSponsors(readableEventId: string): Observable<Sponsorship[]> {
        // console.log('getSponsors: '+readableEventId);
        return this.http.get<Sponsorship[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-sponsors&eventId=${readableEventId}`
        );
    }

    public getCaptcha(readableEventId: string): Observable<Captcha> {
        // console.log('getCaptcha: '+readableEventId);
        return this.http.get<Captcha>(`${environment.apiEndpoint_PROXY}/?mode=event-captcha&eventId=${readableEventId}`);
    }

    public getCustomRegistrationFields(readableEventId: string): Observable<CustomRegistrationFieldModel.CustomRegistrationField[]> {
        // tslint:disable-next-line:max-line-length
        // console.log('getCustomRegistrationFields: '+readableEventId);
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-customregistrationfields&eventId=${readableEventId}`;
        return this.http.get<CustomRegistrationFieldModel.CustomRegistrationField[]>(url);
    }

    public getEventRegistrationCount(readableEventId: string): Observable<number> {
        // console.log('getEventRegistrationCount: '+readableEventId);
        return this.http.get<number>(
            `${environment.apiEndpoint_PROXY}/?mode=event-registrationcount&eventId=${readableEventId}`
        );
    }

    public registerToEvent(readableEventId: string, registrationData: RegistrationData): Observable<RegistrationResult> {
        console.log('registerToEvent: '+readableEventId);
        // console.log('registerToEvent: '+JSON.stringify(registrationData));
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-registration&eventId=${readableEventId}`;
        return this.http.post<RegistrationResult>(url, registrationData); 
    }

    public finalizeRegistration(readableEventId: string, requestData: FinalizeRegistrationRequest): Observable<RegistrationResult> {
        // console.log('finalizeRegistration: '+readableEventId);
        // working, but Bad Gateway! because timeout between Proxy and CRM-API ?
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-registration-finalize&eventId=${readableEventId}`; // NEW API not implemented!
        return this.http.post<RegistrationResult>(url, requestData);
        // let url = 'https://vdutest.crm4.dynamics.com/api/data/v9.1/msevtmgt_finalizeregistrationpayment';
        // const payload='{ "msevtmgt_purchaseid": "'+requestData.purchaseId+'", "msevtmgt_paymentstatus": 100000001 }';
        // return this.http.post<RegistrationResult>(url, payload);
    }

    public registerToSession(readableEventId: string, sessionId: string): Observable<boolean> {
        // console.log('registerToSession: '+readableEventId);
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-registertosession&eventId=${readableEventId}`;//comment
        const body= {'readableEventId': readableEventId,'sessionId': sessionId}
        return this.http.post<boolean>(url,body);
    }
}
